import useParkingLocationCreateRouteConfig from "../../../routes/configs/parking_locations/ParkingLocationCreateRouteConfig";
import useParkingLocationEditRouteConfig from "../../../routes/configs/parking_locations/ParkingLocationEditRouteConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function ParkingLocationsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("parking_locations");

  //Set the datatable fetch info
  config.setFetchRequest("parking_locations");
  config.setFetchParams({ with_parking_location_location_data: true });

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("capacity"),
    useBasicColumnConfig("capacity_for_visitors"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig(
      "parking_location",
      useParkingLocationEditRouteConfig()
    ),
    useDeleteRowActionConfig("parking_location"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "parking_location",
      useParkingLocationCreateRouteConfig()
    ),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default ParkingLocationsDataTable;
